export default function capitalize(input?: string | null): string {
  if (!input) {
    return "";
  }

  return input
    .replace(/[_-]+/g, " ") // Replace underscores and hyphens with spaces
    .trim()
    .split(/\s+/) // Split by any whitespace
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

// Capitalizes only the first character, leaving the rest of the string (and any
// spacing) untouched — safe to call on every keystroke without fighting the caller's input.
export function capitalizeFirstLetter(value: string): string {
  return value.length > 0 ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}

export function capitalizeFirstWord(str: string): string {
  if (!str) return "";
  const [first, ...rest] = str.toLowerCase().split(" ");
  return (
    first.charAt(0).toUpperCase() +
    first.slice(1) +
    (rest.length ? " " + rest.join(" ") : "")
  );
}
